import React from "react";
import { itemSurveyPropType } from "components/propTypes";
import ProductImage from "components/source/shared/product-image";
import {
  getProductImageAltText,
  getProductImageUrlsByOrientation,
  ProductImageOrientation,
  ProductImageSize,
} from "helpers/product-image-helpers";
import ProductImagePath from "helpers/product-image-path";

const propTypes = {
  currentSurvey: itemSurveyPropType.isRequired,
};

const SurveyItemBanner = ({ currentSurvey }) => {
  const { product, size } = currentSurvey;

  const fallBackThumbnailImgSrc = React.useCallback(
    () =>
      product?.images?.[ProductImageOrientation.NO_MODEL.path]
        ? ProductImagePath + product.images[ProductImageOrientation.NO_MODEL.path]?.[ProductImageSize.x480.path]
        : ProductImagePath + product?.images?.[ProductImageOrientation.FRONT.path]?.[ProductImageSize.x480.path],
    [product]
  );

  return (
    <div className="flex border-b border-lighterGray py-3" data-test-id="happiness-survey-item-banner">
      <ProductImage
        className="rounded-md w-20 h-24 aspect-2/2 mr-4 flex-shrink-0"
        altText={getProductImageAltText(product?.displayName, product?.designer?.displayName)}
        imageGroup={getProductImageUrlsByOrientation(product?.images, [ProductImageOrientation.NO_MODEL.path])}
        imageSize={ProductImageSize.x480}
        fallbackSrc={fallBackThumbnailImgSrc()}
      />
      <div className="flex flex-col text-left py-3 gap-4 justify-between">
        <div className="flex flex-col gap-1">
          <p>{product?.designer?.displayName}</p>
          <p className="text-darkGray">{product?.displayName}</p>
        </div>

        <p className="text-sm text-black">
          Size Worn: <span className="text-darkGray">{size}</span>
        </p>
      </div>
    </div>
  );
};

SurveyItemBanner.propTypes = propTypes;
export default SurveyItemBanner;
